import { render, staticRenderFns } from "./clients-assign.vue?vue&type=template&id=9157f9cc&scoped=true&"
import script from "./clients-assign.vue?vue&type=script&lang=js&"
export * from "./clients-assign.vue?vue&type=script&lang=js&"
import style0 from "./clients-assign.vue?vue&type=style&index=0&id=9157f9cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9157f9cc",
  null
  
)

export default component.exports